import { Switch } from "@material-ui/core"

// Cores no padrão global dos switches (tema em routes.js).
const ChaveDisponibilidade = Switch

function DisponibilidadeSwitch({
    produto,
    disponivel,
    handleChangeDisponibilidadeProduto,
    handleChangeDisponibilidadeOpcao,
}) {
    return (
        <ChaveDisponibilidade
            checked={!!disponivel}
            onChange={
                produto ? handleChangeDisponibilidadeProduto : handleChangeDisponibilidadeOpcao
            }
            inputProps={{ "aria-label": "Disponibilidade" }}
        />
    )
}

export default DisponibilidadeSwitch
